/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Algorithm_Sha256Inputs */



/**
* | output |
* | --- |
* | "SHA-256 (recommended)" |
*
* @param {Profile_Security_Totp_Algorithm_Sha256Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_algorithm_sha256 = /** @type {((inputs?: Profile_Security_Totp_Algorithm_Sha256Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Algorithm_Sha256Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SHA-256 (empfohlen)")
	return /** @type {LocalizedString} */ ("SHA-256 (recommended)")
});